import styled from "styled-components";

export const ProductWarrantyStoreNameWidgetStyled = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  text-decoration: underline;
  color: ${({ theme }) => theme.COLORS.GRAY_2};
  font-size: ${({ theme }) => theme.FONT.SIZE.S12};
  font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }
`;

export const ModalBodyStyled = styled.div`
  position: relative;
  border-radius: 1rem;
  max-width: 500px;
  width: 100%;
  padding: 20px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .btn_close_modal {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    z-index: 2;
  }
`;
